export const FacebookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path
      d="M20.525 10.5251C20.525 4.99123 16.0338 0.5 10.4999 0.5C4.96608 0.5 0.474854 4.99123 0.474854 10.5251C0.474854 15.3772 3.92348 19.4173 8.4949 20.3496V13.5326H6.48989V10.5251H8.4949V8.0188C8.4949 6.08396 10.0688 4.51003 12.0037 4.51003H14.5099V7.51754H12.5049C11.9536 7.51754 11.5024 7.96867 11.5024 8.52005V10.5251H14.5099V13.5326H11.5024V20.5C16.5651 19.9987 20.525 15.7281 20.525 10.5251Z"
      fill="#4A148C"
    />
  </svg>
);
